import { Segment } from '@mairistem/composants';

import { ApplicationsSources } from './ApplicationsSources';

const ParametrageApplicationsSources = () => (
  <Segment style={{ width: 800 }}>
    <ApplicationsSources />
  </Segment>
);

export default ParametrageApplicationsSources;
